/// <reference path="../typings/index.d.ts" />

/**
 *
 * Class track basic methods analytics
 *
 *  var tracker=new TrackerAnalytics('campaign');
 *
 */
class TrackerAnalytics {
  private _categoryGeneral: string;

  constructor(campaign?: string) {
    this._categoryGeneral = campaign;
    this.parseLinks();
  }

  /**
   *
   * Parse all dom elements with data-event attribute
   *
   */
  parseLinks(): void {
    $('[data-event]').on('click', (evt, noEvent = false) => {
      if (!$(evt.currentTarget).data('event-manual') && !noEvent) {
        this.sendEvent($(evt.currentTarget));
      }
    });
  }

  /**
   *
   * Parse dom element with data-event attribute
   *
   * data-event:string event parameter for ga method
   *
   *  special attribute options
   *    self - use text from jquery elm
   *      example
   *      <a data-event="self">[name event]</a>
   *      in this example the event parameter for ga method is [name event]
   *    selector - use value from the data-event-selector from jquery elm
   *      example
   *      <a data-event="selector" data-event-selector="span.name"><img src="image.jpg"><span class="prefix">prefix</span><span class="name">[name event]</span></a>
   *      in this example the event parameter for ga method is [name event]
   *
   *
   * data-event-category:string category parameter for ga method, this attribute could be defined in parent dom element or the body tag page
   *
   *
   *
   */
  sendEvent(elm: JQuery): void {
    var category: string;
    var action: string;
    var label: string;
    if (elm.data('event') == 'self') {
      label = elm.text();
    } else if (elm.data('event') == 'selector') {
      label = $(elm.data('event-selector'), elm).text();
    } else {
      label = elm.data('event');
    }
    if (elm.data('event-category')) {
      category = elm.data('event-category');
    } else if (elm.parent().data('event-category')) {
      category = elm.parent().data('event-category');
    } else if ($('body').data('event-category')) {
      category = $('body').data('event-category');
    } else {
      category = this._categoryGeneral;
    }
    if (elm.data('event-action')) {
      action = elm.data('event-action');
    } else if (elm.parent().data('event-action')) {
      action = elm.parent().data('event-action');
    } else {
      action = $('body').data('event-action');
    }
    this.sendEventCustom(category, action, label)
  }

  /**
   *
   * Execute ga standard event method
   *
   * @param action GA Category attribute
   * @param label GA Event attribute
   */
  sendEventCustom(category: string, action: string, label: string): void {
    // if (Tools.isMobile()) {
    //   category += "_movil";
    // }
    ga('send', 'event', category, action, label);
  }

  /**
   *
   * Execute ga standard pageview method
   *
   * @param url GA Urlattribute
   */
  sendPage(url: string): void {
    ga('send', 'pageview', url);
  }
}

class Pages {
  constructor() {
    //console.log("Home:constructor");
  }

  allActions() {
    //console.log("Home:allActions");
  }

  main() {
    //console.log("Home:main");
  }
}

class CommonController {
  constructor() {
    //console.log("CommonController:constructor");
    //console.log("holi");
    new TrackerAnalytics();
  }

  allActions() {
    //console.log("CommonController:allActions");
  }
}

var Public = {
  initiatedClasses: {}
}

var UTIL = {
  exec: function (controller, action = 'allActions') {
    if (window[controller]) {
      if (Public.initiatedClasses[controller]) {
        var controllerClass = Public.initiatedClasses[controller];
      } else {
        var controllerClass = Object.create((<any>window[controller]).prototype);
        controllerClass.constructor.apply(controllerClass);
        Public.initiatedClasses[controller] = controllerClass;
      }
      if (controllerClass[action]) {
        controllerClass[action]();
      }
    }
  },
  init: function () {
    var body = $("body");
    var controller = body.data("router-class");
    var action = body.data("router-action");


    this.exec("CommonController");
    this.exec(controller);
    this.exec(controller, action);
  }
}

$(document).on('ready', function () {
  UTIL.init();
});
